import { render, staticRenderFns } from "./SkillsStudentsTableByStudents.vue?vue&type=template&id=1f69d53e&scoped=true"
import script from "./SkillsStudentsTableByStudents.vue?vue&type=script&lang=js"
export * from "./SkillsStudentsTableByStudents.vue?vue&type=script&lang=js"
import style0 from "./SkillsStudentsTableByStudents.vue?vue&type=style&index=0&id=1f69d53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69d53e",
  null
  
)

export default component.exports